import { create } from 'zustand';
import type { Product } from '../../data/product';

// At most one product is being edited at a time, so the modal lives outside the
// virtualized product table and reads its target from this store. Hosting the
// state inside ActionsCell's useState made the modal a casualty of any column
// re-render that changed cell-function identity (e.g. the order edit page's
// 15-second refresh tick), since React unmounts the old cell instance.
type ProductEditState = {
  editing: Product | null;
  startEditing: (product: Product) => void;
  stopEditing: () => void;
};

export const useProductEditStore = create<ProductEditState>((set) => ({
  editing: null,
  startEditing: (product) => set({ editing: product }),
  stopEditing: () => set({ editing: null }),
}));
